let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6B0zl")).then(() => parcelRequire('hYhFV'));